function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M6.71 0L0 5.856h4.328C4.64 8.659 6.899 9.843 9.22 10.03c-.44 1.121-.251 1.682.439 2.43-2.697.062-6.46 1.62-6.46 4.174.25 2.803 3.95 3.364 5.77 3.364 2.383.062 5.08-1.184 5.644-3.364.251-2.18-.627-3.364-1.944-4.424-1.443-1.12-1.756-1.744-1.317-2.491.94-1.06 2.195-1.683 2.446-3.178.125-1.059-.126-1.744-.376-2.679l2.822-2.367-.063.997a.742.742 0 00-.313.56V9.47c.125.81 1.38.686 1.442 0V3.053c0-.187-.125-.436-.313-.499V.997L18 0H6.71zm3.638 8.784c-3.825.623-5.456-5.42-2.383-6.167 3.512-.686 5.206 5.357 2.383 6.167zm-.313 4.548c3.763.81 3.826 3.925.627 4.86-2.76.56-5.143-.25-5.08-1.87 0-1.557 2.195-2.99 4.453-2.99z"
});

var SvgGoogleScholar = function SvgGoogleScholar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 20,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoogleScholar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-scholar.20d303d1.svg";
export { ForwardRef as ReactComponent };